/**
 * This is for global usage i18n outside vue setup
 */

import { ThemeComponentSize } from '/#/common/theme'

/**
 * It's my keyword for backend.
 * For example /organizations/@my/license-stats
 * For example /licenses/@my
 */
export const MY_KEYWORD = '@my'

export const FAKE_API_KEYWORD = 'fake-api'

/**
 * This is for api request to protect from CSRF.
 */
export const CSRF_TOKEN_KEY = 'x-csrftoken'

export const ACCEPT_LANGUAGE_KEY = 'Accept-Language'

/**
 * This is for api request
 */
export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DDTHH:mmZ'
export const DEFAULT_DATE_FORMAT_WITHOUT_TIME = 'YYYY-MM-DD'

/**
 * This is for making human-readable date
 */
export const DISPLAY_DATE_FORMAT = 'DD MMM YYYY HH:mm'
export const DISPLAY_DATE_FORMAT_WITHOUT_TIME = 'DD MMM YYYY'

export const DISPLAY_DATE_SHORT_MOTH_FORMAT = 'DD.MM.YYYY HH:mm'
export const DISPLAY_DATE_SHORT_MOTH_FORMAT_WITHOUT_TIME = 'DD.MM.YYYY'
/**
 * For all risk score related things.
 */
export const MAX_RISK_SCORE = 100

/**
 * Axios disabled timeout
 */
export const NO_TIMEOUT = 0

/**
 * Table perpage options
 */
export const PER_PAGE_OPTIONS = [10, 20, 50]

export const BODY = document.body

export const MAX_SELECTABLE_OPTIONS = 50

export const DEFAULT_TABLET_BREAK_POINT: Exclude<ThemeComponentSize, 'xxs'> = 'xl'
export const DEFAULT_MOBILE_BREAK_POINT: Exclude<ThemeComponentSize, 'xxs'> = 'sm'

export const CURRENT_YEAR = new Date().getFullYear()
